module.exports = __webpack_public_path__ + "img/device-ua.7f01054f.png";